import parseErrors from '@/lib/errors/parseErrors'
import toastErrors from '@/lib/errors/toastErrors'

export const defaultStoreImports = {
  actions: ['fetchOne'],
  getters: ['loading'],
  state: ['current']
}

export default {
  data() {
    return { errors: [] }
  },
  methods: {
    addErrors(errors) {
      this.errors = errors
    },
    onEndCreated() {
    }
  },
  async created() {
    const { id } = this.$route.params
    if (!this.current || this.current.id !== id) {
      try {
        await this.fetchOne(id)
        return this.onEndCreated()
      } catch (e) {
        this.addErrors(parseErrors(e))
        toastErrors(e)
      }
    }
    return this.onEndCreated()
  }
}
